<template>
	<v-card outlined>
		<v-card-title
			class = "secondary pa-0 body-1 white--text justify-center"
		>
			<v-icon
				
				color  = "primary"
				v-text = "'mdi-tune-vertical'"
				class  = "mx-1"
			></v-icon>
			{{ head.title }}
		</v-card-title>
		<v-card-text
			class = "pa-1"
		>
			<v-row>
				<template
					v-for = "(item_field, idx_field) of info_fields"
				>					
					<v-col
						:xl   = "item_field.colss.xl"
						:md   = "item_field.colss.md"
						:cols = "item_field.colss.cols"
					>
						<!-- enctype 	 = "multipart/form-data" -->
						<v-file-input
						    outlined
						    dense
						 	v-if 		 = "item_field.type == 'file'"
						    v-model 	 = "info[item_field.key]"
						    :label    	 = "item_field.text"
							prepend-icon = "mdi-file-music"							
						></v-file-input>	

						<v-text-field
						    dense
						    outlined
							v-if 		 = "item_field.type == 'text' || item_field.type == 'number'"
							:type 		 = "item_field.type"
							v-model 	 = "info[item_field.key]"
						    :label    	 = "item_field.text"
						></v-text-field>
						  
					</v-col>
				</template>
					<v-col

					>
						
						<v-btn
							
							v-show = "!loading"
							color  = "primary"
							v-text = "$ml.get('save')"
							@click = "save"
						></v-btn>
					</v-col>
			</v-row>
			<v-toolbar						    		
	    		dense
	    		height = "25"
	    		class  = "secondary white--text"
	    	>
	    		<v-icon
					small
					color = "white"
					class = "mr-1"
				>
					mdi-view-list
				</v-icon>
	    		<v-toolbar-title 
	    			class = "body-2"
	    		>
	    			{{ $ml.get('registered_sounds') }}
	    		</v-toolbar-title>
	    	</v-toolbar>
			<v-divider></v-divider>
			<v-data-table
						dense
					    fixed-header
					    :headers 			 = "headers"
					 	:items 				 = "render_list"
					    class 				 = "elevation-5"			    
					    :hide-default-footer = "height < 56 ?  true : false"
					   	:options.sync 		 = "options"
					   	:server-items-length = "total"
					    :height 			 = "height+'px'"
					    item-key 			 = "index"
					    :loading 			 = "loading"
					   	:footer-props 		 = "{
					   		showFirstLastPage: true,
					   		itemsPerPageOptions: [15, 30],
					   		showCurrentPage: true
					   	}"				   	
					>	
						<template v-slot:item.size = "{ item }">
							<span>
								{{ item.size }}  <strong class = "primary--text">GB</strong>
							</span>							
						</template>
						<template v-slot:item.limit = "{ item }">
							<span>
								{{ item.limit }}  <strong class = "primary--text">GB</strong>
							</span>										
						</template>
						<!-- <template v-slot:item.name = "{ item }">
							<span>
								{{ item.name_sound }}
							</span>
						</template> -->
						<template v-slot:item.url_path = "{ item }">
							<v-btn
								outlined
								x-small
								icon
								color  = "primary"
								@click = "render_sound(item.url_path)"
							>							
								<v-icon
									small
									color  = "primary"
									v-text = "'mdi-play'"
								></v-icon>
							</v-btn>
						</template>
						<template  v-slot:item.actions="{ item }">
							<!-- <v-icon
						        small
						        color="primary"
						        class="mr-2"
						        @click="actions('edit', item)"
						    >
						        mdi-pencil
						    </v-icon> -->
						    <v-icon
						        small
						        color  = "error"
						        @click = "actions('confirm_delete', item)"
						        v-if   = "item.id"
						        v-show = "show.delete_sound"
						    >
						       mdi-delete
						    </v-icon>
						</template>
					</v-data-table>
		</v-card-text>
		<v-divider></v-divider>
		<v-card-actions>
			<v-progress-circular
				indeterminate
				v-show = "loading"
				color  = "primary"
				:sise  = "20"
			></v-progress-circular>
			
			<v-spacer></v-spacer>

			
		</v-card-actions>
	</v-card>
</template>
<script>
	import EventBus 		from '@/event-bus'
	import sounds_defaults 	from '@/components/general_parameters/sounds_default.js';	

	export default{
		name 	: 'sounds',
		props 	: [ 'info_to_component' ] ,
		data 	: () => ({
			info 		: {},
			info_fields : [
				{
					key   : 'path',
					text  : 'path',
					type  : 'file',
					colss : {
						xl   : 3,
						md   : 4, 
						cols : 12,
					}
				},
				/*{
					key  : 'name',
					text : 'name',
					type : 'text',
					colss : {
						xl   : 3,
						md   : 4, 
						cols : 12,
					}
				},
				{
					key   : 'url_path',
					text  : 'url_path',
					type  : 'text',
					colss : {
						xl   : 3,
						md   : 4, 
						cols : 12,
					}
				},*/
				// type

			],
			head : {
				title : 'Sounds'
			},
			headers 	: [
				{
					text  : 'name',
					value : 'name',
				},
				{
					text  : 'play',
					value : 'url_path',
				},
				{
					text  : 'type',
					value : 'type',
				},			
				{
					text  : 'actions',
					value : 'actions'
				}
			],
			loading 		: false,
			ID_notification : 'sounds',
			info_item  		: {},
			list 			: sounds_defaults,
			height			: 300,
			options 		: { itemsPerPage : 30},
			total 			: 2,
			show 			: {
				edit_sound   : true,
				delete_sound : true,
			}
		}), // data

		watch : {
			options : {
				handler(){
					this.get_list();
				}, deep: true,
			}
		}, // watch
		
		created(){
			// this.get_list();
			let modul = this.$store.getters["auth/permission"](this.$route.name || "settings", "", "settings");
			if (modul) {
				if (!modul.can_edit) { this.show.edit_sound = false }
				if (!modul.can_delete ) { this.show.delete_sound = false }
			}
		}, // created


		methods : {
			actions(act, item, opt){
				if (act == 'confirm_delete') {
					this.info_item = item;
					EventBus.$emit('notifications_modal', {
						type    : 'confirm_delete',
						ID 		: this.ID_notification
					})
				}
			}, // actions

			async save(){
				if (!this.$store.getters["auth/permission"](this.$route.name || "settings", "can_add", "settings")){
					this.$EventBus.$emit("notifications_modal",{
						type 	: "warning",
						message : this.$ml.get("no_have_permission_create") + " : " + this.$ml.get("settings"),
					});
					return false;
				};
				console.log("SOUNDS : ", this.info);
				let info_up 		=  this.info;
				this.loading 		= true; 
				let confirm_save 	= false;
				let list_error 		= '';

				const api 	 = this.$URL + "/api/v1/sounds";
				const config = {  
					headers: { 'Content-Type': 'multipart/form-data'} 
				}; 
			    // files
			    // for (let file in info_up.path) {
		    	// console.log("key : " ,file);
				let formData = new FormData();

				// let ext = info_up.path && info_up.path.type ? info_up.path.type.split('/')[1] : 'mp3';
				// console.log("EXT : " , ext)
		        formData.append("file", info_up.path, info_up.path.name); //  + '.' + ext/*, info_up.name*/
		       	formData.append("name", info_up.name);
		       	formData.append("type", info_up.type);
		       	// formData.append("name", info_up.name);

				console.log(formData, info_up)
				// console.log("TEST  ",formData.getAll('file'))
				await this.$axios.post(api, formData/*, config */).then(res => {
					console.log("RES logos ", res )
					if (res && res.data) {
						this.list.push(res.data);
						this.total ++;
						// this.info_images[file] = this.$URL + res.data.url_path;
					}
					/**/
				}).catch( er => {
					confirm_save = true;
					list_error += ' ' + file;
					// this.loading = false;
					/*
						er && er.message ? er.message : er
					*/
					console.log("Error logos ", er);
				})
			    // } // for

			    this.loading = false;
			    if (!confirm_save) {
			    	this.$EventBus.$emit('notifications_modal', {
						type : 'saved',
					})
			    }else{
			    	this.$EventBus.$emit('notifications_modal', {
						type 	: 'error',
						message : 'Not saved ' + list_error,
					})
			    }
			},

			get_list(){
				/*const { page, itemsPerPage } = this.options;
				let pg = page;*/
				const api 	 = this.$URL + "/api/v1/sounds";
				
				this.$axios.get(api).then(res => {
					console.log("RES sounds ", res )
					if (res && res.data) {
						let items = res.data;
						if (items.rows && items.rows.length > 0) {
							items.rows.forEach((item_row)=>{
								/*let temp_name = item_row.name.split('.').length > 0 ? item_row.name.split('.')[0] : item_row.name;
								item_row.name_sound = temp_name;*/					
								item_row.url_path = this.$URL + item_row.url_path;
								
							}); // forEach
							this.list = this.list.concat(items.rows);
							this.total = items.count + 2;

						}

						
					}
					/**/
				}).catch( er => {
					console.log("Error get LOGOS : ", er);
				})
			}, // get list

			del(item){
				if (!this.$store.getters["auth/permission"](this.$route.name || "settings", "can_delete", "settings")){
					this.$EventBus.$emit("notifications_modal",{
						type 	: "warning",
						message : this.$ml.get("no_have_permission_delete") + " : " + this.$ml.get("settings"),
					});
					return false;
				};
				if (item && item.id) {

					const api = this.$URL + '/api/v1/sounds/' + item.id +'/';
					this.$axios.delete(api).then(res => {
						console.log("RES delete Sounds : ", res);
						this.$EventBus.$emit('notifications_modal',{
							type : 'deleted',
							// message : 'All images Sounds'
						});
						this.list.splice(this.list.indexOf(item), 1);
						this.total --;
						
					}).catch(er => {
						console.log("Error Sounds : ", er);
						this.$EventBus.$emit('notifications_modal',{
							type : 'error',
							message : 'Deleting Sound'
						})
					})
				} // item

			}, // del

			render_sound(url_audio){			 			
				if (url_audio) {
					console.log("sound play ", url_audio)
					let audio = new Audio(url_audio);
					audio.play();
				}
			}, // render sound

		}, // methods

		computed : {
			render_list: function(){
				return this.list;
			}, // render list
		}, // computed

		mounted(){
			EventBus.$on('notifications_modal' + this.ID_notification , (action)=>{
				if (action) {
					this.del(this.info_item);
				}
			})
		}, // mounted
	};
</script>